module.exports = __webpack_public_path__ + "img/dfclub-big.1728160e.svg";